import { render, staticRenderFns } from "./treeCate.vue?vue&type=template&id=ce941ab4&scoped=true"
import script from "./treeCate.vue?vue&type=script&lang=js"
export * from "./treeCate.vue?vue&type=script&lang=js"
import style0 from "./treeCate.vue?vue&type=style&index=0&id=ce941ab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce941ab4",
  null
  
)

export default component.exports